module.exports = __webpack_public_path__ + "img/maintenance-overlay-bubbles.b754cd5e.png";